module.exports = __webpack_public_path__ + "img/about-04.970c80e0.webp";